<template>
  <div>
    <Header @changeActive="changeActive" ref="headRef"></Header>
    <v-layout class="top-offset" row wrap>
      <v-flex sm12>
        <v-app id="inspire">
            <v-bottom-nav
              :active.sync="active"
              :value="true"
              class="button-nav"
              color="#5a65db"
            >
              <v-btn
                :value="tabRouteNames.ProfileMyAccount"
                @click="selectTab('my-account')"
                color="#5a65db"
                flat
                key="my-account"
              >
                <span>{{$t('my_account')}}</span>
              </v-btn>
              <v-btn
                :value="tabRouteNames.ProfileMyProducts"
                @click="selectTab('my-products')"
                color="#5a65db"
                flat
                key="my-products"
              >
                <span>{{$t('my_products')}}</span>
              </v-btn>
              <v-btn
                :value="tabRouteNames.ProfileMyFriends"
                @click="selectTab('my-friends')"
                color="#5a65db"
                flat
                key="my-friends"
              >
                <span>{{$t('my_friends')}}</span>
              </v-btn>
              <v-btn
                :value="tabRouteNames.ProfileNotifications"
                @click="selectTab('notifications')"
                color="#5a65db"
                flat
                key="notifications"
              >
                <v-badge color="red">
                  <span>{{$t('notifications')}}</span>
                  <span slot="badge" v-if="newNotificationsCount && active !== 3">{{newNotificationsCount}}</span>
                </v-badge>
              </v-btn>
              <v-btn
                :value="tabRouteNames.ProfileMyGroups"
                @click="selectTab('my-groups')"
                color="#5a65db"
                flat
                key="my-groups"
              >
                <span>{{$t('my_groups')}}</span>
              </v-btn>
              <v-btn
                :value="tabRouteNames.ProfileSettings"
                @click="selectTab('settings')"
                color="#5a65db"
                flat
                key="settings"
                v-if="isAdmin"
              >
                <span>{{$t('settings.settings')}}</span>
              </v-btn>
              <v-btn
                :value="tabRouteNames.AddNeeds"
                @click="selectTab('add-needs')"
                color="#5a65db"
                flat
                key="add-needs"
                v-if="isAdmin"
              >
                <span>{{$t('profile.add_need')}}</span>
              </v-btn>
            </v-bottom-nav>
          <div class="text-xs-center">
            <router-view/>
          </div>
        </v-app>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueJwtDecode from 'vue-jwt-decode'
import Header from '../components/global/Header.vue'
import MyAccount from '../components/profilePage/MyAccount'

function decodeJwtToken () {
  let token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token).permissions
  }
  return []
}

export default {
  name: 'ProfilePage',
  components: {
    MyAccount,
    Header
  },
  data: () => ({
    signUpData: {
    },
    active: null,
    apiUrl: process.env.ROOT_API,
    isAdmin: false,
    tabRouteNames: {
      ProfileMyAccount: 0,
      ProfileMyProducts: 1,
      ProfileMyFriends: 2,
      ProfileNotifications: 3,
      ProfileMyGroups: 4,
      ProfileSettings: 5,
      AddNeeds: 6

    }
  }),
  computed: {
    roles: () => decodeJwtToken(),
    ...mapState({
      newNotificationsCount: state => state.profile.newNotificationsCount
    })
  },
  methods: {
    changeActive (tab) {
      this.active = tab
    },
    selectTab (path) {
      if (this.newNotificationsCount && path === 'notifications') {
        this.$store.dispatch('profile/hideNotificationCount').then((res) => {
        }).catch(console.error)
      }
      this.$router.push('/profile/' + path)
    }
  },
  created () {
    this.isAdmin = this.roles.includes('admin')
    this.tabRouteNames[this.$route.name] ? this.changeActive(this.tabRouteNames[this.$route.name]) : this.changeActive(0)
  }
}

</script>

<style lang="scss">
  @import "../assets/sass/desktop/profilePage.scss";
</style>



// WEBPACK FOOTER //
// src/views/ProfilePage.vue